import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API, useAuth } from "../context/AuthContext";
import { getStoredReferral, clearStoredReferral } from "../lib/referral";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const exchange = async () => {
      if (!sessionId) {
        navigate("/");
        return;
      }
      try {
        const refCode = getStoredReferral();
        const headers = { "X-Session-ID": sessionId };
        if (refCode) headers["X-Referral-Code"] = refCode;
        const r = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers,
        });
        if (!r.ok) throw new Error("auth failed");
        const data = await r.json();
        clearStoredReferral();
        setUser(data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/");
      }
    };
    exchange();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="flex-grow flex flex-col items-center justify-center px-6 py-20"
    >
      <p className="font-display text-xl uppercase tracking-widest">
        <span className="blink">▮</span> SYNERGIZING SESSION...
      </p>
      <p className="text-xs uppercase tracking-widest text-[#4B4B4B] mt-3">
        // Authenticating via Emergent Auth
      </p>
    </div>
  );
}
